export default function DashboardSkeleton({ width = '60%', height = '24px', bg = '#2a3040' }) {
  return (
    <div style={{
      width,
      height,
      borderRadius: '4px',
      background: bg,
      animation: 'shimmer 1.5s ease-in-out infinite',
      flexShrink: 0,
    }} />
  );
}

